import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../utils/config";

export default function KYCVerificationStep({ data, setData }) {
    const [checked, setChecked] = useState({
        terms: data?.terms || false,
        commission: data?.commission || false,
        refund: data?.refund || false,
    });

    const [termsDocs, setTermsDocs] = useState({
        seller_terms_and_conditions: "",
        commission_policy: "",
        return_refund_policy: "",
        updated_at: ""
    });

    // Fetch existing Terms & Conditions from GET API
    useEffect(() => {
        const fetchTerms = async () => {
            const token = sessionStorage.getItem("token") || "";
            const headers = {
                "Content-Type": "application/json"
            };
            if (token) {
                headers["Authorization"] = `Bearer ${token}`;
            }

            try {
                const res = await axios.get(`${config.apiEndpoint}/snp/terms-conditions/get`, { headers });

                const resData = res?.data?.data || res?.data;
                if (resData) {
                    const termsUrl = resData.seller_terms_and_conditions || resData["seller-terms-and-conditions"] || resData.sellerTermsAndConditions || resData.terms || "";
                    const commUrl = resData.commission_policy || resData["commission-policy"] || resData.commissionPolicy || resData.commission || "";
                    const refundUrl = resData.return_refund_policy || resData["return-refund-policy"] || resData.returnRefundPolicy || resData.refund || "";

                    setTermsDocs({
                        seller_terms_and_conditions: typeof termsUrl === "string" ? termsUrl : (termsUrl?.url || ""),
                        commission_policy: typeof commUrl === "string" ? commUrl : (commUrl?.url || ""),
                        return_refund_policy: typeof refundUrl === "string" ? refundUrl : (refundUrl?.url || ""),
                        updated_at: resData.updated_at || ""
                    });
                }
            } catch (error) {
                console.error("Failed to fetch terms & conditions in KYC step:", error);
            }
        };

        fetchTerms();
    }, []);

    const handleCheckbox = (e) => {
        const { name, checked: value } = e.target;
        const updated = {
            ...checked,
            [name]: value
        };
        setChecked(updated);
        setData(updated);
        if (value && window.gtag) {
            window.gtag("event", "terms_and_conditions_accepted", {
                event_category: "KYC",
                event_label: "Terms and Conditions Accepted",
            });
        }
    };

    return (
        <div className="container p-0 mt-4">
            <h2 className="h4 fw-semibold text-dark mb-4">
                Terms & Conditions
            </h2>

            <div className="card p-4" style={{ borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                {/* 1. Seller Terms & Conditions */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#F8FAFC", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                    <label className="d-flex align-items-center m-0" style={{ gap: "10px", cursor: "pointer", fontWeight: 500, color: "#1E293B" }}>
                        <input
                            type="checkbox"
                            name="terms"
                            checked={checked.terms}
                            onChange={handleCheckbox}
                            style={{ width: "18px", height: "18px", accentColor: "#FB820A", cursor: "pointer" }}
                        />
                        <span>
                            I accept the{" "}
                            <a
                                href={termsDocs.seller_terms_and_conditions || "#"}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    if (!termsDocs.seller_terms_and_conditions) e.preventDefault();
                                    e.stopPropagation();
                                }}
                                style={{ color: "#FB820A", textDecoration: "underline", fontWeight: 600 }}
                            >
                                Seller Terms & Conditions
                            </a>
                        </span>
                    </label>
                </div>

                {/* 2. Commission Policy */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#F8FAFC", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                    <label className="d-flex align-items-center m-0" style={{ gap: "10px", cursor: "pointer", fontWeight: 500, color: "#1E293B" }}>
                        <input
                            type="checkbox"
                            name="commission"
                            checked={checked.commission}
                            onChange={handleCheckbox}
                            style={{ width: "18px", height: "18px", accentColor: "#FB820A", cursor: "pointer" }}
                        />
                        <span>
                            I accept the{" "}
                            <a
                                href={termsDocs.commission_policy || "#"}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    if (!termsDocs.commission_policy) e.preventDefault();
                                    e.stopPropagation();
                                }}
                                style={{ color: "#FB820A", textDecoration: "underline", fontWeight: 600 }}
                            >
                                Commission Policy
                            </a>
                        </span>
                    </label>
                </div>

                {/* 3. Return & Refund Policy */}
                <div className="p-3 mb-1" style={{ backgroundColor: "#F8FAFC", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                    <label className="d-flex align-items-center m-0" style={{ gap: "10px", cursor: "pointer", fontWeight: 500, color: "#1E293B" }}>
                        <input
                            type="checkbox"
                            name="refund"
                            checked={checked.refund}
                            onChange={handleCheckbox}
                            style={{ width: "18px", height: "18px", accentColor: "#FB820A", cursor: "pointer" }}
                        />
                        <span>
                            I accept the{" "}
                            <a
                                href={termsDocs.return_refund_policy || "#"}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    if (!termsDocs.return_refund_policy) e.preventDefault();
                                    e.stopPropagation();
                                }}
                                style={{ color: "#FB820A", textDecoration: "underline", fontWeight: 600 }}
                            >
                                Return & Refund Policy
                            </a>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    );
}
